import { FC } from 'react';
import { classnames } from '@/utils/classnames';
import {
  generateTextColorClass,
  generateValue,
} from './InteractiveNavChartTooltip.utils';
import { IInteractiveNavChartTooltipProps } from './InteractiveNavChartTooltip.types';

export const InteractiveNavChartTooltip: FC<
  IInteractiveNavChartTooltipProps
> = ({ items }) => {
  return (
    <div className="rtl flex w-40 flex-col gap-y-1">
      {items.map(({ title, type, value, color, isZeroValueVisible }) => {
        if (!value && !isZeroValueVisible) {
          return null;
        }

        const { textColorClass } = generateTextColorClass(color);

        const { generatedValue } = generateValue(type, value!);

        return (
          <div
            key={title}
            className={classnames('flex justify-between', textColorClass)}
          >
            <span>{title}:</span>
            <span>{generatedValue}</span>
          </div>
        );
      })}
    </div>
  );
};
